import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../pages/profile/merchant/Sidebar";
import Header from "../components/header/Header";
// import { Outlet } from "react-router-dom";

const MerchantContainer = () => {
  document.title = "Merchant";
  const merchant = useSelector((store) => store.merchant);

  return (
    <>
      <Header />
      <div className="row ">
        <div className="">
          {merchant ? (
            <Sidebar role="Merchant" />
          ) : (
            <Navigate to="/loginmerchant" />
          )}
        </div>
      </div>
    </>
  );
};

export default MerchantContainer;
